import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import categoriesReducer from './slices/categoriesSlice';
import notificationReducer from './slices/notificationSlice';
import permissionsReducer from './slices/permissionsSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    categories: categoriesReducer,
    notifications: notificationReducer,
    permissions: permissionsReducer,
  },
});

export default store; 